import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent } from './form.component';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill'
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatSelectModule } from '@angular/material/select'; 
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    QuillModule,
    CKEditorModule,
    MatSelectModule,
    SweetAlert2Module,
  ],
  exports: [FormComponent],
  declarations: [FormComponent],
  providers: [],
})
export class FormModule {}
